"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Sidepane = exports.MenuButton = exports.MenuIcon = exports.Spacer = exports.Root = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var css = ".sidepane-spacer { display: none }\n@media screen and (min-width: 40em) {\n.sidepane-root { transform: none !important }\n.sidepane-spacer { display: block }\n}";

var style = _react.default.createElement("style", {
  dangerouslySetInnerHTML: {
    __html: css
  }
});

var toggle = function toggle(state) {
  return {
    isOpen: !state.isOpen
  };
};

var close = function close(state) {
  return {
    isOpen: false
  };
};

var open = function open(state) {
  return {
    isOpen: true
  };
};

var Root = _react.default.forwardRef(function (_ref, ref) {
  var width = _ref.width,
      color = _ref.color,
      bg = _ref.bg,
      open = _ref.open,
      style = _ref.style,
      props = _objectWithoutProperties(_ref, ["width", "color", "bg", "open", "style"]);

  return _react.default.createElement("div", _extends({}, props, {
    ref: ref,
    className: "sidepane-root",
    style: _objectSpread({
      width: width,
      color: color,
      backgroundColor: bg,
      transform: open ? 'none' : 'translateX(-100%)',
      position: 'fixed',
      top: 0,
      left: 0,
      bottom: 0,
      overflowY: 'auto',
      WebkitOverflowScrolling: 'touch',
      transitionProperty: 'transform',
      transitionDuration: '.2s',
      transitionTimingFunction: 'ease-out'
    }, style)
  }));
});

exports.Root = Root;

var Spacer = function Spacer(_ref2) {
  var width = _ref2.width,
      props = _objectWithoutProperties(_ref2, ["width"]);

  return _react.default.createElement("div", _extends({}, props, {
    className: "sidepane-spacer",
    style: {
      width: width,
      flex: 'none'
    }
  }));
};

exports.Spacer = Spacer;

var MenuIcon = function MenuIcon(_ref3) {
  var _ref3$size = _ref3.size,
      size = _ref3$size === void 0 ? 24 : _ref3$size,
      props = _objectWithoutProperties(_ref3, ["size"]);

  return _react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: size,
    height: size,
    style: {
      display: 'block'
    }
  }, _react.default.createElement("path", {
    d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
  }));
};

exports.MenuIcon = MenuIcon;

var MenuButton = _react.default.forwardRef(function (props, ref) {
  return _react.default.createElement("button", _extends({}, props, {
    ref: ref,
    title: "Toggle Menu",
    children: _react.default.createElement(MenuIcon, null),
    style: {
      position: 'fixed',
      top: 0,
      left: 0,
      appearance: 'none',
      border: 0,
      margin: 0,
      padding: '0.5em',
      outline: 'none'
    }
  }));
});

exports.MenuButton = MenuButton;

var Sidepane =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Sidepane, _React$Component);

  function Sidepane() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Sidepane);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Sidepane)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      isOpen: false
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "toggle", _react.default.createRef());

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "update", function (fn) {
      return _this.setState(fn);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleDocumentClick", function (e) {
      if (_this.toggle.current.contains(e.target)) return;

      _this.update(close);
    });

    return _this;
  }

  _createClass(Sidepane, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('click', this.handleDocumentClick);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.handleDocumentClick);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var isOpen = this.state.isOpen;

      var _this$props = this.props,
          width = _this$props.width,
          Toggle = _this$props.Toggle,
          props = _objectWithoutProperties(_this$props, ["width", "Toggle"]);

      return _react.default.createElement(_react.default.Fragment, null, style, _react.default.createElement(Toggle, {
        ref: this.toggle,
        onClick: function onClick(e) {
          e.stopPropagation();

          _this2.update(toggle);
        }
      }), _react.default.createElement(Spacer, {
        width: width
      }), _react.default.createElement(Root, _extends({
        open: isOpen,
        width: width
      }, props)));
    }
  }]);

  return Sidepane;
}(_react.default.Component);

exports.Sidepane = Sidepane;

_defineProperty(Sidepane, "defaultProps", {
  Toggle: MenuButton,
  width: 256,
  bg: 'white'
});

var _default = Sidepane;
exports.default = _default;